// extracted by mini-css-extract-plugin
export default {"textareaMin":"ProductInformationSection_textareaMin__MUOY2"};